import { Panel, PanelProps, PanelType } from '@/libraries/design/components/panel/src/panel';
import { RichTextComponent } from '@/libraries/design/utils';

interface UniformPanelProps {
	panelType: PanelType;
	label: string;
	description: string;
	richText: string;
}

const UniformPanel = (props: UniformPanelProps) => {
	const panelProps: PanelProps = {
		panelType: props.panelType,
		label: props.label,
		description: props.richText ? (
			<RichTextComponent text={props.richText} />
		) : (
			(props.description ?? null)
		),
	};
	return <Panel {...panelProps} />;
};

export default UniformPanel;
